export const QUERY_NAMING = {
  uiName: "Image Query",
  uiNamePlural: "Image Queries",
  kebabCase: "image-query",
  kebabCasePlural: "image-queries",
};
